module.exports = __webpack_public_path__ + "static/media/child_care_support.7ffd824d.svg";